import * as React from 'react';

import { Root } from './styled';


type WideContentProps = {}

const WideContent: React.SFC<WideContentProps> = ({ children }) => {
	return (
		<Root>
			{children}
		</Root>
	);
}

export {
	WideContent
}